/**
 * Label for a tour in a picker, filter or chip: `[id:1234] Name (Recurring)`,
 * or `[id:1234] Name (start - end)` for a bespoke tour (CP-5865, CP-6115).
 *
 * Accepts a tour object or a bare id (filters restored from the URL hold ids
 * until the tour is fetched). The `(Recurring)` / date suffix is only added
 * when the object carries `is_bespoke`, so callers holding a slim `{id, name}`
 * don't mislabel a bespoke tour as recurring.
 *
 * `formatDate` lets a caller render the bespoke dates in its own style.
 */
export function formatTourOptionLabel(tour, formatDate = (d) => d) {
    if (tour == null || tour === '') return '';
    if (typeof tour !== 'object') return `[id:${tour}]`;

    const parts = [];
    if (tour.id != null) parts.push(`[id:${tour.id}]`);
    if (tour.name) parts.push(tour.name);
    if (tour.is_bespoke === false) {
        parts.push('(Recurring)');
    } else if (tour.is_bespoke) {
        const dates = [tour.start_date, tour.end_date].filter(Boolean).map(formatDate).join(' - ');
        if (dates) parts.push(`(${dates})`);
    }
    return parts.join(' ');
}
